<template>
    
    <div class="c-text-between px-container c-flex-wrap"> 
      <div class="title-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span style="color: #587380;font-size: 12px;">基于我们机器人平台的解决方案</span>
        <h1>以机器人技术与人工智能驱动创新</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          我们的机器人平台赋能远见者探索、协作、创造与分享——推动机器人技术与人工智能的进步，并在多元行业实现变革性应用。
        </span>
        <div class="c-text-justify-start c-flex-wrap">
          <div class="buttonSite c-mr-20 c-mb-10"> 
            <a  @click="$router.push('/company')">了解更多</a>
          </div> 
        </div>
      </div>
      <div class="title-width">
        <img src="@/assets/images/\applications/V2companion (1).jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div> 
    <div id="physical-ai-applications"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">从演示到部署的 AI 全生命周期</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container" style="margin-top: 80px;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1 style="text-align: left;">面向学术与企业研究的物理智能</h1>
        <span class="c-mt-10 c-mb-60 c-text-left text-indent">
         Franka Robotics 提供专为研究团队和开发物理智能的公司量身定制的产品原型。FR3 Duo 能够通过单一系统实现演示、数据集生成和策略执行。研究人员可以演示双臂技能、采集最高质量的数据（包括触觉数据），并通过 Franka 控制接口（FCI）获得底层 1 kHz 的控制访问权限，从而部署和测试策略。
         </span>
      </div> 
    </div> 
    <div class="px-container stress-content c-mb-10"> 
      <div v-for="(item, index) in aiList" :key="item.name + index" 
        style="min-height: 180px; ">
        
        <div style="aspect-ratio: 270/200;">
          <div  style="width: 100%;" class="c-text-both" v-show="!item.iframeValue"> 
            <img :src="item.url" style="width: 100%;aspect-ratio: 270/200;" />
            <div class="playButton "  @click="item.iframeValue = true">  
            </div>
          </div>
          <iframe
              :src="item.videoUrl" v-if="item.iframeValue"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              allowfullscreen="true"
            ></iframe> 
        </div> 
        <div class="c-text-left c-width-precent-100 c-mt-10 c-mb-10" style="color: #587380;font-size: 12px;">
          {{ item.name }}
        </div>
        <div class="c-text-left c-width-precent-100 c-font-weight">
          {{ item.value }}
        </div>
      </div>
    </div>  
     <div class="px-container stress-content"> 
      <a href="https://example.com/" target="_blank" style="width: 100%;">
        <img src="@/assets/images/applications/AI services (1).png" alt="" style="width: 100%;">
      </a>
    </div>   
    <div id="application-research"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">学术与企业研究</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container" style="margin-top: 80px;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1 style="text-align: left;">从AI、机器学习、机器人控制与运动规划，到操作、人机协作和仿人机器人</h1>
        <span class="c-mt-10 c-mb-60 c-text-left text-indent">
          对于处于AI与机器人技术前沿的研究人员，FRANKA RESEARCH 3 提供了一个参考型力敏感机器人平台和强大的控制接口，帮助实现快速结果和学术发表。
          我们的平台还为寻找自动化实验设置的机械臂的研究人员提供了低门槛，同时也支持教授机器人控制和自动化课程。
         </span>
      </div> 
    </div> 
    <div class="px-container stress-content"> 
      <div v-for="(item, index) in contentList" :key="item.name + index" 
        style="min-height: 180px; ">
        
        <div style="aspect-ratio: 270/200;">
          <div  style="width: 100%;" class="c-text-both" v-show="!item.iframeValue"> 
            <img :src="item.url" style="width: 100%;aspect-ratio: 270/200;" />
            <div class="playButton "  @click="item.iframeValue = true">  
            </div>
          </div>
          <iframe
              :src="item.videoUrl" v-if="item.iframeValue"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              allowfullscreen="true"
            ></iframe> 
        </div> 
        <div class="c-text-left c-width-precent-100 c-mt-10 c-mb-10" style="color: #587380;font-size: 12px;">
          {{ item.name }}
        </div>
        <div class="c-text-left c-width-precent-100 c-font-weight">
          {{ item.value }}
        </div>
      </div>
    </div>  
    <div id="application-innovation"></div>
    <div class="line-with-text px-container"  >
      <hr class="divider">
      <span class="line-text">机器人技术创新</span>
      <hr class="divider">
    </div>
    
    <div class="c-text-between px-container" >
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1 style="text-align: left;">服务机器人与创新应用</h1>
        <span class="c-mt-10 c-mb-60 c-text-left text-indent">我们的机器人通过自动化日常任务、提高效率并提升客户体验和生活质量，
          推动农业、医疗、酒店和零售等行业的发展。这些创新应用促进了行业转型，并为增长创造了新的机会。
         </span>
      </div> 
    </div> 
    <div class="px-container stress-content"> 
      <div v-for="(item, index) in applyList" :key="item.name + index" 
        style="min-height: 180px; ">
        <div style="aspect-ratio: 270/200;">
          <div  style="width: 100%;" class="c-text-both" v-show="!item.iframeValue"> 
            <img :src="item.url" style="width: 100%;aspect-ratio: 270/200;" />
            <div class="playButton "  @click="item.iframeValue = true">  
            </div>
          </div>
          <iframe
              :src="item.videoUrl" v-if="item.iframeValue"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              allowfullscreen="true"
            ></iframe> 
        </div> 
        <div class="c-text-left c-width-precent-100 c-mt-10 c-mb-5" style="color: #587380;font-size: 12px;">
          {{ item.name }}
        </div>
        <div class="c-text-left c-width-precent-100  c-mb-5">
           <h2>{{ item.title }}</h2> 
        </div>
        <div class="c-text-left c-width-precent-100  c-font-weight">
          {{ item.value }}
        </div>
      </div>
    </div>  
    <div id="application-industry"></div>
    <div class="line-with-text px-container" >
      <hr class="divider">
      <span class="line-text">新型工业自动化</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <h1 style="text-align: left;">工业应用需要灵活性和精确的力反馈 </h1>
        <span class="c-mt-10 c-mb-60 c-text-left text-indent">机械臂的每个关节都配备力矩传感器，赋能机器人的精细操作和精准力控，
          使其能够适应不同的工作平面。在其工作范围内，机器人臂展不仅能达到855mm的位置，还能实现接近底座的灵活动作。
          七轴的几何结构使其能够采取复杂姿势，进入狭小空间，在封闭环境中也能顺利执行各类任务。 
         </span>
      </div> 
    </div> 
    <div class="px-container feedback-content"> 
      <div v-for="(item, index) in feedbackList" :key="item.name + index" class="c-mb-20" 
        style="min-height: 180px; ">
        <div style="aspect-ratio: 716/450;">
          <div  style="width: 100%;" class="c-text-both" v-show="!item.iframeValue"> 
            <img :src="item.url" style="width: 100%;aspect-ratio: 716/450;" />
            <div class="playButton "  @click="item.iframeValue = true">  
            </div>
          </div>
          <iframe
              :src="item.videoUrl" v-if="item.iframeValue"
              width="100%"
              height="100%"
              frameborder="0"
              scrolling="no"
              allowfullscreen="true"
            ></iframe> 
        </div> 
        <!-- <div  style="width: 100%;" class="c-text-both"> 
           <img :src="item.url" style="width: 100%;aspect-ratio: 716/450;" />
           <div class="playButton ">  
           </div>
        </div> -->
        <div class="c-text-left c-width-precent-100 c-mt-10 c-mb-5" style="color: #587380;font-size: 12px;">
          {{ item.name }}
        </div>
        <div class="c-text-left c-width-precent-100  c-mb-5">
           <h2>{{ item.title }}</h2> 
        </div>
        <div class="c-text-left c-width-precent-100 c-font-weight">
          {{ item.value }}
        </div>
      </div>
    </div>  
    
    <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center; margin-top: 120px;">
            <h2 class="c-zIndex-2">Franka Robotics帮助您实现您理想中的解决方案</h2> 
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2">
                <!-- <div class="buttonSite">  -->
                    <router-link to="/contact"  class="buttonSite">联系我们的团队</router-link>
                <!-- </div> -->
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
    </div>
  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        applyList:[
          {
            name:'GIMELLI-SMYZE',
            title:'机器人酒吧',
            value:'跟Smyze机器人酒吧打个招呼吧，这家酒吧已经在瑞士的几个地方成功运营，并将继续在全球扩张。',
            url:require('@/assets/images/applications/hqdefault (13).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1bu96YqEYM'

          },
          {
            name:'GIMELLI-SMYZE',
            title:'RACLETTE机器人',
            value:'SMYZE xFranka 机器人制作瑞士烤奶酪。',
            url:require('@/assets/images/applications/hqdefault (15).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1bu96YqEJy'
          }, 
        ],
        aiList:[],
        contentList:[
          {
            name:'帝国理工学院',
            value:'RLBench：机器人学习基准',
            url:require('@/assets/images/applications/hqdefault (4).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1t396YKEsH'
          },
          {
            name:'奥尔堡大学',
            value:'强化学习在外太空环境中机器人岩石抓取学习的应用',
            url:require('@/assets/images/applications/hqdefault (5).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1t396YKETx'
          },
          {
            name:'爱丁堡机器人中心',
            value:'通过低维度描述符学习障碍物避让的耦合项',
            url:require('@/assets/images/applications/hqdefault (6).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1t396YKEY7'
          },
          {
            name:'代尔夫特理工大学',
            value:'使用主动推理的机器人机械手新型自适应控制器',
            url:require('@/assets/images/applications/hqdefault (9).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1U396YKEbG'
          },
          {
            name:'意大利科技研究所',
            value:'用于 MOCA 机车操纵控制的远程操作界面',
            url:require('@/assets/images/applications/hqdefault (10).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1m396YKE82'
          },
          {
            name:'伯明翰大学',
            value:'规划最大可操纵性切割路径 RRT-RMM',
            url:require('@/assets/images/applications/hqdefault (11).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1t396YKEYx'
          },
        ], 
        feedbackList:[
          // {
          //   name:'机器照看',
          //   title:'机器装载',
          //   value:'在Maschinenfabrik Reinhausen GmbH，仅在3小时内就建立并成功实施了机器加载应用程序。',
          //   url:require('@/assets/images/applications/Rheinhausen.af88c67.png')
          // },
          {
            name:'上下料自动化',
            title:'压机装载',
            value:'压机制动器上料和卸料过程的完全自动化',
            url:require('@/assets/images/applications/hqdefault.jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1tu96YqEXF'
          },
          {
            name:'机床操作',
            title:'数控加工',
            value:'Vision ToolRoom是一个包含Franka机器人的移动平台，是数控加工中理想的协作伙伴。',
            url:require('@/assets/images/applications/hqdefault (16).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1tu96YqEDr'
          },
          // {
          //   name:'质量检查',
          //   title:'PCB测试',
          //   value:'可以测量和记录过程数据，例如成功执行和施加的力：质量控制的附加价值。',
          //   url:require('@/assets/images/applications/hqdefault (17).jpg')
          // },
          {
            name:'质量检查',
            title:'电池舱耐久性试验',
            value:'操作触摸屏来解锁电池，将其推出并放入，这样的测试一次又一次地重复。',
            url:require('@/assets/images/applications/hqdefault (18).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1bu96YqE1n'
          },
          {
            name:'质量检查',
            title:'触摸屏测试',
            value:'由于机器人的灵敏操作，对触摸屏等易碎部件的生产线末端测试成为可能。',
            url:require('@/assets/images/applications/hqdefault (19).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1tu96YqEih'
          },
          // {
          //   name:'组装',
          //   title:'组装',
          //   value:'装配站可以精确地拧紧销钉，同时控制扭矩。',
          //   url:require('@/assets/images/applications/hqdefault (20).jpg')
          // },
          {
            name:'组装',
            title:'电子产品组装',
            value:'一台机器装载着不同的部件——没有任何保护栅栏。',
            url:require('@/assets/images/applications/hqdefault (21).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1tu96YqE16'
          },
          {
            name:'组装',
            title:'Franka 装配',
            value:'装配站可以精确地拧入膨胀螺栓，并同时控制扭矩。',
            url:require('@/assets/images/applications/hqdefault (27).jpg'),
            iframeValue:false,
            videoUrl:'https://player.bilibili.com/player.html?bvid=BV1Uu96YqEfw'
          },
          // {
          //   name:'搬运/处理',
          //   title:'N.I.S.T.测试板',
          //   value:'由美国国家标准与技术研究院开发的一种测试板，用于测试机器人在紧固螺母、连接连接器、啮合齿轮和插针时的性能。',
          //   url:require('@/assets/images/applications/hqdefault (23).jpg')
          // },
          // {
          //   name:'搬运/处理',
          //   title:'组装',
          //   value:'将最终产品组件放置到其包装中，利用力灵敏度和微调力应用，实现成功，坚固的配合。',
          //   url:require('@/assets/images/applications/hqdefault (24).jpg')
          // },
          // {
          //   name:'搬运/处理',
          //   title:'包装',
          //   value:'由于对接触的力敏感，机器人可以根据力反馈将物体移动到目标位置，无需预先确定精确的位置。',
          //   url:require('@/assets/images/applications/hqdefault (25).jpg')
          // },
        ],
      }
    }, 
  }
  </script>
  
  <style scoped> 
  /* 导航栏容器的样式 */
  nav {
    color: #1B2F36;
    /* 背景色 */
  }
  
  
  /* 栅格布局，将 <ul> 设置为水平排列 */
  ul.navbar {
    list-style-type: none;
    display: flex;
    padding: 10px;
  }
  
  /* 每个 <li> 的样式 */
  ul.navbar li {
    position: relative;
    /* 相对定位，用于子菜单的绝对定位 */
    /* margin: 0 20px;   */
  }
  
  /* 链接的样式 */
  ul.navbar li a {
    text-decoration: none;
    /* 去掉下划线 */
    font-size: 14px;
    padding: 10px 15px;
    /* 内边距 */
    display: block;
  }
  
  /* 子菜单（下拉菜单）样式 */
  ul.dropdown-menu {
    /* border: 1px solid #1b2f364f; */
    border: 1px solid #e5e7eb;
    box-sizing: border-box;
    list-style-type: none;
    position: absolute;
    /* 绝对定位 */
    top: 100%;
    /* 放置在父菜单项的下方 */
    left: 0;
    background-color: white;
    /* 背景色 */
    display: none;
    /* 初始状态下隐藏 */
    width: 150px;
    /* 设置子菜单宽度 */
    border-radius: 5px;
    /* 圆角 */
    padding: 5px;
    /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);  */
  }
   
  
  /* 鼠标悬停时显示子菜单 */
  ul.navbar li:hover>.dropdown-menu {
    display: block;
    /* 显示子菜单 */
  
  
  }
  /* 默认情况下，一行展示 4 个项目 */
  .stress-content {
    display: flex;
    flex-wrap: wrap; 
    justify-content: flex-start;
    gap: 53px;
  }
  .feedback-content {
    display: flex;
    flex-wrap: wrap; 
    justify-content: space-between;
  } 
  .company-content{ 
    display: flex;
    flex-wrap: wrap;  
  }
  .stress-content > div {
    width: calc(25% - 40px); /* 4 个项目 */
  }
  .feedback-content > div {
    width: calc(33% - 40px); /* 4 个项目 */
  }
  .company-content > div {
    width: calc(16.5% - 40px); /* 4 个项目 */
  }
  .display-width{
    width: 100%
  } 
  
  .title-width {
    width: calc(50% - 40px);
  }
  .ending-width{
    width: 35%;
  }
  .logo-alt {
    display: none; /* 默认隐藏 logo.svg */
  }
  
.action-height{
  height: 400px;
  background-color: #d5dbdc; 
  position: relative;
}
  
@media (max-width: 1029px) {
    .action-width{
        width: calc(50% - 40px);
    }
    } 
  /* 屏幕宽度小于 1200px 时，一行展示 3 个 */
  @media (max-width: 1199px) {
    .stress-content > div {
      width: calc(33.33% - 40px); /* 3 个项目 */
    }
    /* .stress-content { 
      gap: 53px;
    } */
    .company-content > div {
      width: calc(25% - 40px); /* 3 个项目 */
    } 
    .logo-main {
      display: none; /* 隐藏 logo-and-claim.svg */
    }
  
    .logo-alt {
      display: block; /* 显示 logo.svg */
    }
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .stress-content > div {
      width: calc(50% - 40px); /* 2 个项目 */
    }  
    .feedback-content > div {
        width: calc(50% - 20px); /* 4 个项目 */
    }
    .company-content > div {
      width: calc(33% - 40px); /* 3 个项目 */
    } 
    
  .title-width {
      width:100%
  }
    .display-width{
      width:100%
    }
    .ending-width{
      width: 100%;
      margin-top: 40px;
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
    .stress-content > div {
      width: 100%; /* 1 个项目 */
    }  
    .feedback-content > div {
        width: 100%; /* 4 个项目 */
    }
    .company-content > div {
      width: calc(50% - 40px); /* 3 个项目 */
    } 
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
  